import React from 'react';
import {Languages, useLanguage} from '../LanguageContext';
import '../AppHeader.css';
import { RiGlobalLine } from "react-icons/ri";


const LanguageDropdown: React.FC = () => {
    const {language, changeLanguage} = useLanguage();

    return (
        <div
            className="language-dropdown-container"
            style={{display: 'flex', alignItems: 'center', flexDirection: 'rtl' ? 'row' : 'row-reverse'}}
        >
            <RiGlobalLine/>
            <select className="language-dropdown"
                    value={language}
                    onChange={(e) => changeLanguage(e.target.value as Languages)}
            >
                {Object.values(Languages).map((lang) => (
                    <option key={lang} value={lang}>
                        {lang}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LanguageDropdown;